import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";

export const Header = ({ t, lang, setLang }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "services", label: t.nav.services, testid: "nav-services-link" },
    { id: "about", label: t.nav.about, testid: "nav-about-link" },
    { id: "stats", label: t.nav.stats, testid: "nav-stats-link" },
    { id: "contact", label: t.nav.contact, testid: "nav-contact-link" },
  ];

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0A101D]/90 backdrop-blur-xl border-b border-[#D4AF37]/15 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
          <Logo light />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="text-sm text-slate-300 hover:text-[#E5C365] transition-colors tracking-wide"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <div className="flex items-center border border-[#D4AF37]/30 rounded-full overflow-hidden text-xs font-mono">
            <button
              data-testid="lang-switch-fr"
              onClick={() => setLang("fr")}
              className={`px-3 py-1.5 transition-colors ${lang === "fr" ? "bg-[#D4AF37] text-[#0A101D] font-semibold" : "text-slate-300 hover:text-[#E5C365]"}`}
            >
              FR
            </button>
            <button
              data-testid="lang-switch-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-[#D4AF37] text-[#0A101D] font-semibold" : "text-slate-300 hover:text-[#E5C365]"}`}
            >
              EN
            </button>
          </div>
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollTo("contact")}
            className="hidden sm:block px-5 py-2.5 text-sm bg-[#D4AF37] text-[#0A101D] font-semibold tracking-wide hover:bg-[#E5C365] transition-colors rounded-sm"
          >
            {t.nav.cta}
          </button>
        </div>
      </div>
    </motion.header>
  );
};
